import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import getFilteredDateFormatOptions from '../utils/getFilteredDateFormatOptions';

const getNewDateFormat = () => {
    let optionState = getRegionalOptions();
    let { UserOptions } = getUserConfiguration();

    let newDateFormat = optionState.selectedDateFormat || UserOptions.DateFormat;
    if (getFilteredDateFormatOptions().indexOf(newDateFormat) === -1) {
        // The user changed locales to one that didn't support their previous date format, and didn't update the selection
        // Default to the first option compatible with their locale
        newDateFormat = getFilteredDateFormatOptions()[0];
    }
    return newDateFormat;
};

export default getNewDateFormat;
